export default function formatNodes([node, ...nodes], nodesMap = {}) {
  if (!node) return nodesMap

  nodesMap[node.id] = {
    ...node,
    nodes: node.nodes && node.nodes.length ? formatNodes(node.nodes) : {}
  }

  return formatNodes(nodes, nodesMap)
}



// WEBPACK FOOTER //
// ./src/modules/Node/helpers/formatNodes.js